import { render, staticRenderFns } from "./LoginNav.vue?vue&type=template&id=4a97b46c&scoped=true&"
import script from "./LoginNav.vue?vue&type=script&lang=js&"
export * from "./LoginNav.vue?vue&type=script&lang=js&"
import style0 from "./LoginNav.vue?vue&type=style&index=0&id=4a97b46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97b46c",
  null
  
)

export default component.exports